var dates={
  "SF": "顺丰速运",
  "HTKY": "百世快递",
  "ZTO": "中通快递",
  "STO": "申通快递",
  "YTO": "圆通速递",
  "YD": "韵达速递",
  "YZPY": "邮政快递包裹",
  "EMS": "EMS",
  "HHTT": "天天快递",
  "JD": "京东快递",
  "UC": "优速快递",
  "ZJS": "宅急送",
  "AJ": "安捷快递",
  "ALKJWL": "阿里跨境电商物流",
  "AX": "安迅物流",
  "AYUS": "安邮美国",
  "AMAZON": "亚马逊物流",
  "AOMENYZ": "澳门邮政",
  "ANE": "安能物流",
  "ADD": "澳多多",
  "AYCA": "澳邮专线",
  "AXD": "安鲜达",
  "ANEKY": "安能快运",
  "ABGJ": "澳邦国际",
  "ANNTO": "安得物流",
  "AUODEXPRESS": "澳德物流",
  "A4PX": "转运四方",
  "ALWL": "安鹿物流",
  "BDT": "八达通  ",
  "BETWL": "百腾物流",
  "BJXKY": "北极星快运",
  "BNTWL": "奔腾物流",
  "BFDF": "百福东方",
  "BFAY": "八方安运",
  "BTWL": "百世快运",
  "BBFZY": "帮帮发转运",
  "BCTWL": "百城通物流",
  "CFWL": "春风物流",
  "CHTWL": "诚通物流",
  "CXHY": "传喜物流",
  "CITY100": "城市100",
  "CEVA": "CEVA物流",
  "CJKD": "城际快递",
  "CNPEX": "CNPEX中邮快递",
  "COE": "COE东方快递",
  "CSCY": "长沙创一",
  "CDSTKY": "成都善途速运",
  "CTG": "联合运通",
  "CRAZY": "疯狂快递",
  "CBO": "CBO钏博物流",
  "CNEX": "佳吉快运",
  "CND": "承诺达",
  "CSTD": "畅顺通达",
  "DSWL": "D速物流",
  "DLG ": "到了港",
  "DTWL": "大田物流",
  "DEKUN": "德坤",
  // eslint-disable-next-line no-dupe-keys
  "DBL": "德邦快运/德邦物流",
  "DML": "大马鹿",
  // eslint-disable-next-line no-dupe-keys
  "DNWL": "丹鸟物流",
  "EST365": "东方汇",
  "DYJ": "递易家",
  "ETK": "E特快",
  "EMS2": "EMS国内",
  "EWE": "EWE",
  "ETONG": "E通速递",
  "ESDEX": "卓志速运",
  "FKD": "飞康达",
  "FTD": "富腾达  ",
  "FYKD": "凡宇货的",
  "FASTGO": "速派快递",
  "FBKD": "飞豹快递",
  "FBOX": "丰巢",
  "FWX": "丰网速运",
  "FHKD": "飞狐快递",
  "FRGYL": "复融供应链",
  "FYPS": "飞远配送",
  "FYSD": "凡宇速递",
  "FT": "丰通快运",
  "GD": "冠达   ",
  "GDEMS": "广东邮政",
  "GSD": "共速达",
  "GTONG": "广通       ",
  "GDKD": "冠达快递",
  "GHX": "挂号信",
  "GTKD": "广通速递",
  "GTKY": "高铁快运",
  "GAI": "迦递快递",
  "GKSD": "港快速递",
  "GTSD": "高铁速递",
  "HGLL": "黑狗冷链",
  "HLWL": "恒路物流",
  "HOAU": "天地华宇",
  "HOTSCM": "鸿桥供应链",
  "HPTEX": "海派通物流公司",
  "hq568": "华强物流",
  "HQSY": "环球速运  ",
  "HXLWL": "华夏龙物流",
  "HBJH": "河北建华",
  "HDKD": "汇达快递",
  "HF": "汇丰物流",
  "HHKD": "华航快递",
  "HHWL": "华翰物流",
  // eslint-disable-next-line no-dupe-keys
  "HMSD": "海盟速递",
  "HQKY": "华企快运",
  "HSWL": "昊盛物流",
  "HTWL": "鸿泰物流",
  "HXWL": "豪翔物流 ",
  "HFHW": "合肥汇文",
  "HLONGWL": "辉隆物流",
  "HQKD": "华企快递",
  "HRWL": "韩润物流",
  "HTKD": "青岛恒通快递",
  "HYH": "货运皇物流",
  "HLYSD": "好来运快递",
  "HJWL": "皇家物流",
  "HISENSE": "海信物流",
  "HSSY": "汇森速运",
  "HTB56": "徽托邦物流",
  "JAD": "捷安达  ",
  "JGSD": "京广速递",
  "JIUYE": "九曳供应链",
  "JXD": "急先达",
  "JYKD": "晋越快递",
  "JCEX": "佳成国际",
  "JTKD": "捷特快递",
  "JYSY": "精英速运",
  "JYM": "加运美",
  "JGWL": "景光物流",
  "JYWL": "佳怡物流",
  // eslint-disable-next-line no-dupe-keys
  "JDWL": "金大物流",
  "JTSD": "极兔速递",
  "KYSY": "跨越速运",
  "KFW": "快服务",
  "KSDWL": "快速递物流",
  "KLWL": "康力物流",
  "KTKD": "快淘快递",
  "KYDSD": "快优达速递",
  "KYWL": "跨越物流",
  "KBSY": "快8速运",
  "LB": "龙邦快递",
  "LHKD": "蓝弧快递",
  "LJD": "乐捷递",
  "LJS": "立即送",
  "LHT": "联昊通速递",
  "MB": "民邦快递",
  "MHKD": "民航快递",
  "MK": "美快    ",
  "MDM": "门对门快递",
  "MD": "迈达",
  "MSKD": "闽盛快递",
  "MRDY": "迈隆递运",
  "MLWL": "明亮物流",
  "NFCM": "南方传媒物流",
  "NJSBWL": "南京晟邦物流",
  "NEWGISTICS": "Newgistics",
  "NEDA": "能达速递",
  "PADTF": "平安达腾飞快递",
  "PANEX": "泛捷快递",
  "PJ": "品骏快递",
  "PXWL": "陪行物流",
  "PCA": "PCA Express",
  "QCKD": "全晨快递",
  "QRT": "全日通快递",
  "QUICK": "快客快递",
  "QXT": "全信通",
  "QYZY": "七曜中邮",
  "RFD": "如风达",
  "RQ": "荣庆物流",
  "RRS": "日日顺物流",
  "RLWL": "日昱物流",
  "RFEX": "瑞丰速递",
  "SAD": "赛澳递",
  "SNWL": "苏宁物流",
  "SAWL": "圣安物流",
  // eslint-disable-next-line no-dupe-keys
  "SDWL": "上大物流",
  "SFWL": "盛丰物流",
  "ST": "速通物流",
  "STWL": "速腾快递",
  "SUBIDA": "速必达物流",
  "SDEZ": "速递e站",
  "SCZPDS": "速呈宅配",
  "SURE": "速尔快递",
  "SDHH": "山东海红",
  "SHWL": "盛辉物流",
  "SJWL": "穗佳物流",
  "STSD": "三态速递",
  "SXHMJ": "山西红马甲",
  "SYKD": "世运快递",
  "SS": "闪送",
  "STKD": "盛通快递",
  "SJ": "郑州速捷",
  "SX": "顺心捷达",
  "SQWL": "商桥物流",
  "SYJWDX": "佳旺达物流",
  "SENDCN": "速递中国",
  "TAIWANYZ": "台湾邮政",
  "TSSTO": "唐山申通",
  "TJS": "特急送",
  "TYWL": "通用物流",
  "TDHY": "华宇物流",
  "THTX": "通和天下",
  "TLWL": "腾林物流",
  "TJDGJWL": "泰捷达物流",
  "UAPEX": "全一快递",
  "UBI": "UBI",
  "UEQ": "UEQ Express",
  "USEX": "美国快递",
  "WJK": "万家康  ",
  "WJWL": "万家物流",
  "WHTZX": "武汉同舟行",
  "WPE": "维普恩",
  "WM": "中粮我买网",
  // eslint-disable-next-line no-dupe-keys
  "WTP": "微特派",
  "WTWL": "温通物流",
  "WJEXPRESS": "文捷航空速递",
  "XCWL": "迅驰物流  ",
  "XFEX": "信丰物流",
  "XYT": "希优特",
  "XBWL": "新邦物流",
  "XLYT": "祥龙运通",
  "XJ": "新杰物流",
  "XIAOBI": "晓毕物流",
  "XDEXPRESS": "迅达速递",
  "YAD": "源安达快递",
  "YCWL": "远成物流",
  "YCSY": "远成快运",
  "YDH": "义达国际物流",
  "YDT": "易达通  ",
  "YFHEX": "原飞航物流",
  "YFSD": "亚风快递",
  "YTKD": "运通快递",
  "YXKD": "亿翔快递",
  "YUNDX": "运东西网",
  "YMDD": "壹米滴答",
  "YZBK": "邮政国内标快",
  "YZTSY": "一站通速运",
  "YFSUYUN": "驭丰速运",
  "YSDF": "余氏东风",
  "YF": "耀飞快递",
  "YDKY": "韵达快运",
  "YL": "云路",
  "YBJ": "邮必佳",
  "YFEX": "越丰物流",
  "YJSD": "银捷速递",
  "YLJY": "优联吉运",
  "YLSY": "亿领速运",
  "YMWL": "英脉物流",
  "YSH": "亿顺航",
  "YSKY": "音素快运",
  "YTD": "易通达",
  "YTFH": "一统飞鸿",
  "YTOGJ": "圆通国际",
  "YXWL": "宇鑫物流",
  "YZGN": "包裹/平邮/挂号信",
  "YZT": "一智通",
  "YBWL": "优拜物流",
  "YLFWL": "一路发物流",
  "YJWL": "云聚物流",
  "ZENY": "增益快递",
  "ZTKY": "中铁快运",
  "ZTWY": "中天万运",
  "ZWYSD": "中外运速递",
  "ZY_AZY": "澳转运",
  "ZY_BDA": "八达网",
  "ZY_BYECO": "贝易购",
  "ZY_CTM": "赤兔马转运",
  "ZY_CUL": "CUL中美速递",
  "ZY_ETD": "ETD",
  "ZY_FCKD": "风驰快递",
  "ZY_FLSD": "风雷速递",
  "ZY_HCYD": "皓晨优递",
  "ZY_HDB": "海带宝",
  "ZY_HFMZ": "汇丰美中速递",
  "ZY_HJSD": "豪杰速递",
  "ZY_HMKD": "华美快递",
  "ZY_HTAO": "360hitao转运",
  "ZY_HTCUN": "海淘村",
  "ZY_HTKE": "365海淘客",
  "ZY_HTONG": "华通快运",
  "ZY_HXKD": "海星桥快递",
  "ZY_HXSY": "华兴速运",
  "ZY_IHERB": "LogisticsY",
  "ZY_LPZ": "领跑者快递",
  "ZY_LZWL": "量子物流",
  "ZY_MBZY": "明邦转运",
  "ZY_MJ": "美嘉快递",
  "ZY_MZ": "168 美中快递",
  "ZY_OEJ": "欧e捷",
  "ZY_OZF": "欧洲疯",
  "ZY_OZGO": "欧洲GO",
  "ZY_QMT": "全美通",
  "ZY_SCS": "SCS国际物流",
  "ZY_SOHO": "SOHO苏豪国际",
  "ZY_SONIC": "Sonic-Ex速递",
  "ZY_TCM": "通诚美中快递",
  "ZY_TPAK": "TrakPak",
  "ZY_TTHT": "天天海淘",
  "ZY_TZKD": "天泽快递",
  "ZY_XDKD": "迅达快递",
  "ZY_XDSY": "信达速运",
  "ZY_XGX": "新干线快递",
  "ZY_XJ": "信捷转运",
  "ZY_YGKD": "优购快递",
  "ZY_YJSD": "友家速递(UCS)",
  "ZY_YPW": "云畔网",
  "ZY_YSW": "易送网",
  "ZYQS": "中运全速",
  "ZYWL": "中邮物流",
  "ZHQKD": "汇强快递",
  "ZTE": "众通快递",
  "ZTOKY": "中通快运",
  "ZYKD": "中邮快递",
  // eslint-disable-next-line no-dupe-keys
  "ZHWL": "中骅物流",
  "ZTWL": "中铁物流",
  "ZHN": "智汇鸟",
  "ZYE": "众邮快递",
  "ZHONGHUAN": "中环快递"
}

export default dates;